
import { Component, Prop, Vue } from "vue-property-decorator";
import { ILbl } from "./ILbl";
import Bus from "@/lib/Bus";
import  ButtonVue from "@/lib/Button.vue";
import OrderVue from "../order/OrderVue.vue";
import CalendarVue from "../calendar/CalendarVue.vue"
import { LblSvc } from "./LblSvc"
import { Next, Route } from 'vue-router';
import { IPrj, Prj } from "@/prj/IPrj";
import { Finder, IFinder } from "@/finder/IFinder";
import { ITree } from "@/tree/ITree";
import  ClipUseMultiVue from "@/clip/ClipUseMulti.vue";

import DbgVue from "@/Dbg.vue";
import FinderInline from "@/finder/FinderInline.vue";
import { MasterData } from "@/store/MasterData";
import Store from "@/store/Store";
import {LblValidator} from "../../server/src/lbl/LblValidator";
import  WykrojnikSelectedVue from "@/wykrojniki/WykrojnikSelectedVue.vue";
import TasksVue from  "@/task/Tasks.vue";
import { ITaskParent } from "server/src/task/ITaskParent";
import { ObjEvents } from "@/../server/src/mqtt/ObjEvents";
import { IGroup } from "../groups/IGroup";
import { EmailExtractor } from "./EmailExtractor"
import ClipMulti from "../clip/ClipMulti";

const bus: Bus = new Bus().getBus();


@Component({ async beforeRouteEnter(to: Route, from: Route, next: Next<LblVue>) {
            console.log("beforeRouteEnter:", to.path)
            next((vm: LblVue) => {  });
        },
        components: {  OrderVue, CalendarVue, ButtonVue,  DbgVue, FinderInline, WykrojnikSelectedVue, TasksVue, ClipUseMultiVue} 
        })

export default class LblVue extends Vue {
 
  @Prop(Number) header:any;
  lbl: ILbl | undefined = undefined;
  key: number = 0;
  key_idx: number = 0;
  debug: boolean = false;
  tasks_key=0
  grupy_key=0
  maile_key=0
  last_changed_by?: string
  
  @Prop(String)id!: any;
  
  lblSvc=new LblSvc();
  prj_finder:IFinder=new Finder();
  tree:ITree|undefined = undefined

  customer_finder:IFinder=new Finder();
  customers:any[]=[]
  @Prop(Boolean) show_images:boolean =  true;
  
  validator: LblValidator= new LblValidator()
  masterData: MasterData|undefined;

  nawijanie_file: string = ""
  changed_by?:string
  changed_date?:Date | undefined
  task_parent: ITaskParent | undefined;

  async chg() {


    if (!this.lbl) return;
    
    this.nawijanie_file = this.lbl?.nawijanie? '/nawijanie_'+this.lbl?.nawijanie.substring(0,2)+".png" : ""

    
    await this.validator.validate(this.lbl,"")

    console.log("lbl:chg", this.lbl.idn)

    const lbl =  await this.lblSvc.update(this.lbl)
    if (lbl && lbl.version) {
      this.lbl.version = lbl.version;
      this.$emit('lbl_changed', this.lbl)
    }
    //this.key++;
  }

  async chg_idx() {
    console.log("lbl:chg_idx")
    if (!this.lbl) return;

    const lbl =  await this.lblSvc.update(this.lbl)
    if (lbl && lbl.version) {
      this.lbl.version = lbl.version;
    }
    this.key_idx++
  }


  async refresh(changed_by?:string, changed_date?:Date) {

    if (changed_date) {
      this.changed_by = changed_by
      this.changed_date = changed_date
      const diffInMs = Math.abs(new Date().getTime() - changed_date.getTime());
      const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
      if (diffInMinutes<10) {
        //alert("użytkownik "+changed_by+" wprowadza tu zmiany. Ostatnia zmiana: "+changed_date.toISOString() )
      }
    }

    this.masterData =  await (await new Store().getStore()).masterData;
    if (!this.masterData) return;
    this.customers     = this.masterData.customers

    if (!this.id) return;

    const l = await this.lblSvc.find_by_id( this.id.toString() );
    
    if (l) {
      this.lbl = l;
      await new EmailExtractor().use_groups_from_clipboard(this.lbl.groups, this.lbl)
      this.nawijanie_file = this.lbl?.nawijanie? '/nawijanie_'+this.lbl?.nawijanie.substring(0,2)+".png" : ""
    
      this.id=l._id;
      if (this.lbl && this.lbl.parent_id) {
        this.task_parent = { lbl_id: this.lbl._id, lbl_url: "" } 
        
        this.prj_finder._id = this.lbl?.parent_id;
        this.prj_finder.text = this.lbl?.projekt_idn;
        }


      this.key++;
    }
    
  }

 

async update_finder(finder:Finder, kk:[]) {
    
    if (!finder._id) return;
    (<any> finder).changed = undefined;

    for (let i=0;i<kk.length;i++) {
      let k=<any> kk[i]
      if (k._id == finder._id) {
     
        if (k.text != finder.text) {
          
          (<any> finder).changed = k;
          k.data=finder.data
          k.filter=finder.filter
          this.key++
        }
      }
    }
  }
/*
  async show_indeks() {
    if (!this.lbl) return;
    if (!this.lbl.idx_id) {
      const idx:IIdx=new Idx()

      const obj=await new IdxSvc().update_idx(idx);
      if (obj && obj._id) {
        this.lbl.idx_id=obj._id
        const obj1 =  await this.lblSvc.update(this.lbl)
        this.lbl.idx_id = obj._id;
        window.router.push({ path: `/etykiety/${this.lbl._id}/indeks` }) 
      }
    } else {
      window.router.push({ path: `/etykiety/${this.lbl._id}/indeks` }) 
    }
  }
*/
  async del_label(l: ILbl) {
    if (confirm("Na pewno skasować etykietę?")) {
      l.status = "SKASOWANY";
      const lbl = await this.lblSvc.set_status(l);

      alert("Etykieta została skasowana")
    }
  }


  async mounted() {
    bus.register("kalkulacja_selected", this.kalkulacja_selected);
    bus.register("surowiec_podst_selected", this.surowiec_podst_selected);
    bus.register("wykrojnik_selected", this.wykrojnik_selected);
    bus.register("jm_selected", this.jm_selected);
    bus.register("tree_modified", this.tree_modified);
    bus.register("prj_selected", this.prj_selected);
    bus.register(ObjEvents.status_changed, this.status_changed);

    bus.register(ObjEvents.event_insert, this.message_received);
    bus.register(ObjEvents.event_update, this.message_received);
    bus.register(ObjEvents.event_delete, this.message_received);
    //console.log("lbl mounted", this.$route.params.prj_id);

    await this.refresh();
    //console.log(this.lbl?.groups)
  }

 

 
  async beforeDestroy() {
    bus.remove("kalkulacja_selected", this.kalkulacja_selected);
    bus.remove("surowiec_podst_selected", this.surowiec_podst_selected);
    bus.remove("wykrojnik_selected", this.wykrojnik_selected);
    bus.remove("jm_selected", this.jm_selected);
    bus.remove("tree_modified", this.tree_modified);
    bus.remove("prj_selected", this.prj_selected);
    bus.remove(ObjEvents.status_changed, this.status_changed);

    bus.remove(ObjEvents.event_insert, this.message_received);
    bus.remove(ObjEvents.event_update, this.message_received);
    bus.remove(ObjEvents.event_delete, this.message_received);
 
 }

  tree_modified(e: any) {
    this.chg();
  }

  kalkulacja_selected() {
    this.chg();
  }

  surowiec_podst_selected() {
    this.chg();
  }

  wykrojnik_selected() {
    this.chg();
  }

  jm_selected() {
    this.chg();
  }


  async create_nowy_lub_korekta() {
    // mapping od p. Henryka
  }


  async show_technologia(tree_id:string) {
    window.router.push({ path: "/technologie/"+tree_id}) 
    this.key++
  }




  async create_project() {

    if (this.lbl && !this.lbl?.parent_id) {
      let prj: IPrj = new Prj()
      prj.idn = this.lbl?.projekt_idn;
      prj.uwagi =  this.lbl?.uwagi
      prj.handlowiec_tmp = this.lbl.handlowiec
      prj.klient_tmp = this.lbl.klient
      prj = <IPrj> await bus.call("/api/projekt/add", prj);
      if (prj) {
        this.lbl.parent_id = prj._id
        await this.chg()
        alert("Stworzono projekt dla etykiety. Wybierz klienta i handlowca.")
        window.router.push({ path: "/projekty/"+prj._id}) 
      }
      else {
        alert("Nie udało się stworzyć projektu")
        return;
      }
    }
  }

 public async prj_selected(e:any) {

   if (e.detail._id && this.lbl) {
    const prj:any = e.detail;
    console.log(e.detail)
    if (!confirm("Przenieść etykietę do projektu "+prj.text+ "?")) return
    const lbl = await new LblSvc().assign_prj(this.lbl, prj);
    if (lbl && lbl.version) {
      this.lbl = lbl;
      alert("Etykieta przeniesiona do projektu "+prj.text)
    }
    this.key++;
   }
  }
/*
  async idx_changed(idx:IIdx) {
    if (!this.lbl) return;
    this.lbl.nr_indeksu_erp = idx.nr_indeksu;

      const l:ILbl=this.lbl

      console.log(idx._id)
      console.log(idx.nazwa_etykiety)
      console.log(idx.nr_indeksu)
      console.log(idx.nr_indeksu_wzor)
      console.log(idx.numer_indeksu_u_klienta)


      l.idx_id                     = idx._id
      l.idx_nazwa_etykiety         = idx.nazwa_etykiety
      l.idx_nr_indeksu_erp         = idx.nr_indeksu
      l.idx_nr_indeksu_wzor_erp    = idx.nr_indeksu_wzor
      l.idx_numer_indeksu_u_klienta= idx.numer_indeksu_u_klienta 
 
      l.version++
      const lbl:any = await new LblSvc().update(l);
      if (lbl) this.lbl = lbl

      this.key++;
  }
*/ 
  termin_wysylki_changed(date:Date) {
    if (!this.lbl) return;
    this.lbl.termin_wysylki = date;
    alert(date)
    this.chg();
  }

  async show_lbl(lbl_id:string, prj_id:string) {
    window.router.push({ path: `/projekty/${prj_id}/etykiety/${lbl_id}` })  
    //window.location.reload(true); 
  }


  obj_to_clipboard(lbl:ILbl) {
    let str=""
    if (!lbl) return "";
    if (!lbl._id) return "";

    str=JSON.stringify(lbl,null,2)
    navigator.clipboard.writeText(str)
    alert("Skopiowano JSON (lbl) do clipboardu")
    return str;
  }

    async status_changed(e:any) {

      const obj = e.detail;
      console.log("received mqtt",obj)
      if (!this.lbl) return;
      if (!this.lbl._id) return;
      
      if (obj.type=="lbl") {
        if (obj._id!=this.lbl._id) return;
        //alert("Lbl: Etykieta zmieniła status na "+obj.status)
        await this.refresh(obj.changed_by, obj.changed_date)
      } 
  }

  message_received(e:any) {
    const obj = e.detail;
    console.log(">>>>>>>>>>>>>>>>>>>>>>>>received mqtt",obj)
    if (!this.lbl) return;
    
    
    if (obj.type=="task") {
      if (!this.lbl._id) return;
      if (obj.parent?.lbl_id == this.lbl._id) {
        this.tasks_key++
      }
    }
    
    if (obj.type=="op") {
        if (!this.lbl._id) return;
   
        if (obj.parent?.lbl_id == this.lbl._id) {
          const user = bus.get_user().data_username
          if (obj.changed_by!=bus.get_user().data_username) {
             if (this.last_changed_by!=obj.changed_by) {
              this.last_changed_by=obj.changed_by
              alert("Użytkownik "+obj.changed_by+" właśnie wprowadził tu zmiany. Ostatnia zmiana: "+obj.changed_date)
             }
          }
          
          this.refresh()
        }
      }
  }

  

   

  
  async use_groups_from_clipboard(groups: IGroup[]) {
      
      if (!this.lbl) return;
      new EmailExtractor().use_groups_from_clipboard(groups, this.lbl)
      const lbl1 =  await this.lblSvc.update(this.lbl)
      if (lbl1 && lbl1._id) {
        this.lbl = lbl1
      }
      this.maile_key++
  }



  async reset_emails(groups:IGroup[],i:number) {
    if (this.lbl) {
      this.lbl.groups=[]
      this.lbl.email_do_akceptacji=[]
      this.lbl.email_do_akceptacji_text=""
      const clip = new ClipMulti().getClip()
      clip.reset("groups")
    }
    this.grupy_key++
    this.maile_key++
  }

  async disconnect_lbls(lbl: ILbl) {
    await new LblSvc().disconnect_lbls(lbl)
    await this.refresh()
  }

}

